<template>
  <!-- قسم الدعم فقط -->
  <section class="support-section">
    <div class="horizontal-slide d-flex" data-direction="left" data-speed="slow">
      <div class="slide-list d-flex">
        <div class="support-item">
          <h2>أفضل سعر مضمون</h2>
        </div>
        <div class="support-item">
          <h2>إلغاء مجاني</h2>
        </div>
        <div class="support-item">
          <h2>أعلى درجات الأمان</h2>
        </div>
        <div class="support-item">
          <h2>أحدث تحديثات السيارات</h2>
        </div>
        <div class="support-item">
          <h2>ثقة مضمونة</h2>
        </div>
      </div>
    </div>
  </section>
</template>
